import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {getConfig} from "../../utils/envUtil";
import {getLocationHostname} from "../../api/BrowserWrapper";
import {loadScript, loadStylesheet} from "../../utils/cdnLoaderUtil";
import {LoginContentApi} from "../../api/LoginContentApi";

/* eslint-disable max-len */
const AON_LOGO = "data:image/svg+xml;base64,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";
/* eslint-enable max-len */

const WIDGET_VERSION = "7.44.1";
const WIDGET_JS_URL = `https://global.oktacdn.com/okta-signin-widget/${WIDGET_VERSION}/js/okta-sign-in.min.js`;
const WIDGET_CSS_URL = `https://global.oktacdn.com/okta-signin-widget/${WIDGET_VERSION}/css/okta-sign-in.min.css`;

interface IOktaWidget {
    renderEl: (options: {el: HTMLElement}, onSuccess: () => void, onError: (err: unknown) => void) => void;
    remove: () => void;
}

type IOktaSignInConstructor = new (config: Record<string, unknown>) => IOktaWidget;

declare global {
    interface Window {
        OktaSignIn: IOktaSignInConstructor;
    }
}

export const LoginV2Page: React.FunctionComponent = () => {
    const widgetRef = useRef<HTMLDivElement>(null);
    const [widgetLoaded, setWidgetLoaded] = useState(false);
    const [loadError, setLoadError] = useState<string | null>(null);
    const [countryCode, setCountryCode] = useState<string>("");

    useEffect(() => {
        LoginContentApi.getCountryCode()
            .then((code) => setCountryCode(String(code)))
            .catch(() => setCountryCode(""));
    }, []);

    useEffect(() => {
        let widget: IOktaWidget | null = null;

        const initWidget = async () => {
            try {
                await Promise.all([
                    loadScript(WIDGET_JS_URL),
                    loadStylesheet(WIDGET_CSS_URL)
                ]);

                const config = getConfig();
                const clientId = config.FRONTEND_CONFIG_OKTA_CLIENT_ID;
                const issuer = config.FRONTEND_CONFIG_OKTA_ISSUER;

                const basename = config.FRONTEND_CONFIG_ENVIRONMENT !== "local"
                    ? `https://${config.FRONTEND_CONFIG_HOSTNAME}`
                    : `https://${getLocationHostname()}:8080`;

                const redirectUri = `${basename}/login/callback`;

                widget = new window.OktaSignIn({
                    baseUrl: issuer.replace("/oauth2/default", ""),
                    clientId,
                    redirectUri,
                    authParams: {
                        issuer,
                        scopes: ["openid", "profile", "email"],
                        pkce: true
                    },
                    useInteractionCodeFlow: true,
                    logo: AON_LOGO,
                    i18n: {
                        en: {
                            "primaryauth.title": "Sign In"
                        }
                    },
                    features: {
                        registration: false,
                        rememberMe: true,
                        showPasswordToggleOnSignInPage: true
                    }
                });

                if (widgetRef.current) {
                    widget.renderEl(
                        {el: widgetRef.current},
                        () => {
                            const searchParams = new URLSearchParams(window.location.search);
                            const raw = searchParams.get("redirect") || "/home";
                            const safeRedirect = raw.startsWith("/") && !raw.startsWith("//") ? raw : "/home";
                            window.location.href = safeRedirect;
                        },
                        (_err: unknown) => {
                            // Okta widget error - widget displays its own error UI
                        }
                    );
                    setWidgetLoaded(true);
                }
            } catch {
                setLoadError("Unable to load the sign-in form. Please refresh the page or try again later.");
            }
        };

        void initWidget();

        return () => {
            if (widget) {
                widget.remove();
            }
        };
    }, []);

    return (
        <div className="login-v2" data-testid="login-v2">
            <div className="login-v2__auth-panel">
                <div className="login-v2__auth-content">
                    <div className="login-v2__header">
                        <h2 className="login-v2__welcome">Welcome Back! Your country is {countryCode ? ` (${countryCode})` : ""}</h2>
                        <p className="login-v2__subtitle">Sign in to access your investment insights</p>
                    </div>

                    {loadError ? (
                        <div className="login-v2__error" role="alert">
                            <p>{loadError}</p>
                        </div>
                    ) : !widgetLoaded ? (
                        <div className="login-v2__loading" aria-label="Loading sign-in form">
                            <div className="login-v2__spinner" />
                        </div>
                    ) : null}

                    <div ref={widgetRef} className="login-v2__widget-container" />
                </div>
            </div>
        </div>
    );
};
